import React from 'react';
import Image from 'next/image';

import useMediaQuery from 'utils/useMediaQuery';
import { ReleaseCalculator } from 'components/ReleaseCalculator';
import { phone } from 'icons/default';
import { Icon } from 'components/tokens/Icon';
import { Colors } from 'enums/Colors';

import styles from './ReleaseHero.module.scss';

interface Props {
  partner: string;
}

export const ReleaseHero: React.FC<Props> = ({ partner }) => {
  const [isMobile, setIsMobile] = React.useState(Boolean);
  const max768px = useMediaQuery('(max-width: 768px)');

  React.useEffect(() => {
    setIsMobile(max768px);
  }, [max768px]);

  const mobileSrc = '/assets/images/release-hero-mobile-min.jpg';
  const desktopSrc = '/assets/images/release-hero-desktop-min.jpg';
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <Image
          layout="fill"
          objectFit="cover"
          src={isMobile ? mobileSrc : desktopSrc}
          alt="Release hero"
        />
        <div className={styles.texts}>
          <h1>Kan vi sänka din månadskostnad?</h1>
          <p>
            Med Blipp kan du fortsätta leasa din företagsbil med ett nytt avtal anpassat efter just
            ditt företag.
          </p>
          <ul>
            <li>Se över dina kostnader </li>
            <li>Försäkringserbjudande ingår</li>
            <li>Samla alla leasingavtal på ett ställe</li>
          </ul>

          <p>
            Prata med en av våra leasingexperter direkt:
            <br />
            <a className={styles.phoneNumber} href="tel:010-1463730">
              <Icon size={20} icon={phone} color={Colors.Yellowish} /> 010-1463730
            </a>
          </p>
        </div>
        <div className={`${styles.texts} ${styles.calculatorWrapper}`}>
          <ReleaseCalculator partner={partner} />
        </div>
      </div>
    </div>
  );
};
